import axiosClient from './axiosClient';

export interface UnmetRequirement {
  key: string;
  label: string;
  actionType: string;
}

export interface SubTask {
  name: string;
  status: string;
  assigneeName?: string;
  assigneeRole?: string;
}

export interface ActionItem {
  opportunityId: string;
  title: string;
  agencyName: string;
  currentPhase: string;
  currentPhaseDisplayName: string;
  dueDate?: string;
  dueTime?: string;
  phaseEnteredAt?: string;
  daysInCurrentPhase: number;
  unmetRequirements: UnmetRequirement[];
  totalRequirements: number;
  actionSummary: string;
  phaseDeadline?: string;
  daysUntilPhaseDeadline?: number;
  phaseDeadlineOverdue?: boolean;
  assigneeName?: string;
  assigneeRole?: string;
  subTasks?: SubTask[];
}

export const actionItemApi = {
  getAll: async (): Promise<ActionItem[]> => {
    const response = await axiosClient.get('/action-items');
    return response.data;
  },

  getCount: async (): Promise<number> => {
    const response = await axiosClient.get('/action-items/count');
    return response.data.count;
  },

  getBoard: async (): Promise<ActionItem[]> => {
    const response = await axiosClient.get('/action-items/board');
    return response.data;
  },
};
